import { ChangeDetectionStrategy, Component } from '@angular/core'

@Component({
  selector: 'app-card-layout-content-title',
  template: ` <div class="p-text-center"><ng-content></ng-content></div> `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardLayoutContentTitleComponent {
  constructor() {}
}
